/*
 * ZAKU predictive search — wires the header search input(s) to the dropdown shell
 * (snippets/predictive-search.liquid) using the Shopify Predictive Search API
 * (section-rendering variant) so results reuse the theme's Liquid product/collection cards.
 * Debounced fetch · PRODUCTS/COLLECTIONS tabs · arrow-key navigation · Esc · click-outside.
 */
(function () {
  var header = document.querySelector('[data-zk-header]');
  var panel = header && header.querySelector('[data-predictive-search]');
  if (!panel) return;

  var results = panel.querySelector('[data-predictive-results]');
  var idle = panel.querySelector('[data-predictive-idle]');
  var viewAll = panel.querySelector('[data-predictive-viewall]');
  var inputs = Array.prototype.slice.call(header.querySelectorAll('[data-predictive-input]'));
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MIN = 2, DEBOUNCE = 250;
  var timer, controller, lastTerm = '', activeTab = 'products';

  var mobile = window.matchMedia('(max-width: 1199px)');
  var panelInput = panel.querySelector('[data-predictive-panel-input]');
  // Set while we programmatically move focus, so the focus handler does not
  // immediately reopen the panel (the old CLOSE bug).
  var suppressOpen = false;
  function focusQuietly(el) {
    if (!el) return;
    suppressOpen = true;
    el.focus();
    suppressOpen = false;
  }

  // Mobile: the panel is a full-height layer ABOVE the open menu drawer (the
  // drawer stays open underneath and is visible again once search closes).
  function open() {
    if (panel.hasAttribute('data-open')) return;
    panel.setAttribute('data-open', '');
    panel.setAttribute('aria-hidden', 'false');
    inputs.forEach(function (i) { i.setAttribute('aria-expanded', 'true'); });
  }
  function close(returnFocus) {
    panel.removeAttribute('data-open');
    panel.setAttribute('aria-hidden', 'true');
    inputs.forEach(function (i) { i.setAttribute('aria-expanded', 'false'); });
    if (!returnFocus) return;
    // Desktop: back to the header input. Mobile: back to the drawer input.
    var target = mobile.matches ? header.querySelector('[data-zk-drawer] [data-predictive-input]') : inputs[0];
    focusQuietly(target);
  }
  // On mobile the visible input lives inside the panel; hand focus over to it.
  function handoffToPanel(from) {
    if (!panelInput || from === panelInput) return;
    panelInput.value = from.value;
    open();
    focusQuietly(panelInput);
  }
  function showIdle() { if (idle) idle.hidden = false; clearInjected(); }
  function clearInjected() {
    Array.prototype.slice.call(results.children).forEach(function (c) {
      if (c !== idle) results.removeChild(c);
    });
  }

  function setTab(tab) {
    activeTab = tab;
    panel.querySelectorAll('[data-ptab]').forEach(function (b) {
      var on = b.getAttribute('data-ptab') === tab;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panel.querySelectorAll('[data-ppanel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-ppanel') !== tab;
    });
  }

  function updateCounts(scope) {
    var counts = scope.querySelector('[data-predictive-counts]');
    panel.querySelectorAll('[data-tab-count]').forEach(function (el) {
      var n = counts && counts.getAttribute('data-count-' + el.getAttribute('data-tab-count'));
      el.textContent = n && n !== '0' ? '(' + n + ')' : '';
    });
  }

  function search(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    results.setAttribute('aria-busy', 'true');
    var url = root.replace(/\/$/, '') +
      '/search/suggest?q=' + encodeURIComponent(term) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection,article&resources[limit]=8';
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (idle) idle.hidden = true;
        clearInjected();
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        while (tmp.firstChild) results.appendChild(tmp.firstChild);
        updateCounts(results);
        setTab(activeTab || 'products'); // keep the tab the user picked (COLLECTIONS stays on COLLECTIONS)
        results.setAttribute('aria-busy', 'false');
        open();
      })
      .catch(function (e) { if (e.name !== 'AbortError') results.setAttribute('aria-busy', 'false'); });
  }

  function onInput(e) {
    var term = e.target.value.trim();
    inputs.forEach(function (i) { if (i !== e.target) i.value = e.target.value; });
    if (viewAll) viewAll.href = root.replace(/\/$/, '') + '/search?q=' + encodeURIComponent(term) + '&type=product,article';
    clearTimeout(timer);
    if (term.length < MIN) { lastTerm = ''; showIdle(); open(); return; }
    if (term === lastTerm) { open(); return; }
    lastTerm = term;
    timer = setTimeout(function () { search(term); }, DEBOUNCE);
  }

  function focusables() { return Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled])')); }
  function moveFocus(dir) {
    var items = focusables();
    if (!items.length) return;
    var idx = items.indexOf(document.activeElement);
    items[(idx + dir + items.length) % items.length].focus();
  }

  inputs.forEach(function (input) {
    input.setAttribute('aria-controls', 'zk-predictive');
    input.setAttribute('aria-expanded', 'false');
    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      if (suppressOpen) return;
      if (mobile.matches) { handoffToPanel(input); return; }
      if (input.value.trim().length >= MIN || idle) open();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); open(); moveFocus(1); }
      else if (e.key === 'Escape') { close(); }
    });
  });
  panel.setAttribute('id', 'zk-predictive');

  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(true); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); moveFocus(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); moveFocus(-1); }
  });
  panel.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-ptab]');
    if (tab) { e.preventDefault(); setTab(tab.getAttribute('data-ptab')); return; }
    if (e.target.closest('[data-predictive-close]')) { close(true); }
  });

  // Outside-close on pointerdown, not click: when tapping the drawer input the
  // panel opens on focus (mousedown) and covers the pointer, so the later
  // `click` is dispatched to a shared ancestor outside the panel and would
  // close it again immediately. At pointerdown the target is still the input.
  document.addEventListener('pointerdown', function (e) {
    if (!panel.contains(e.target) && !inputs.some(function (i) { return i.contains(e.target); })) close();
  });
})();
